import API from 'utils/api';
import getFormattedValues, { hasFiles } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/liquidaciones-empleados-anexos';

const files = ['archivo'];

const getValuesAndConfig = (values) => {
  // multipart solo cuando se sube un archivo nuevo (igual que Documentos de Empleado)
  const config = hasFiles(values, files)
    ? { headers: { 'Content-Type': 'multipart/form-data' } }
    : {};
  const formattedValues = getFormattedValues(values, {
    files,
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

/**
 * GET Liquidaciones Empleados Anexos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getLiquidacionesEmpleadosAnexos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Liquidacion Empleado Anexo
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getLiquidacionEmpleadoAnexo = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Liquidacion Empleado Anexo
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postLiquidacionEmpleadoAnexo = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Liquidacion Empleado Anexo
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchLiquidacionEmpleadoAnexo = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Liquidacion Empleado Anexo
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteLiquidacionEmpleadoAnexo = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
